import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
// import BookingPage from './pages/BookPage';
// import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
// import RefundPolicyPage from './pages/RefundPolicy';
// import LegalNoticePage from './pages/LegalNotice';
// import TermsAndConditionsPage from './pages/TermsAndConditions';
import HomePage from './home';
import PrivacyPolicy from './privacy/PrivacyPolicy';
import { LegalNotice } from './privacy/LegalNotice';
import RefundPolicy from './privacy/RefundPolicy';
import TermsAndConditions from './privacy/TermsAndConditions';

function App() {
  return <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/book" element={<BookingPage />} /> */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/legal-notice" element={<LegalNotice />} />
        </Routes>
      </Router>
}

export default App;